module.exports = __webpack_public_path__ + "img/popup_intercept.4ad4289b.png";